export default [
  {
    title: 'Tổng quan',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    roleId: 1
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'speed',
    name: 'ReportManagement',
    roleId: 1,
    items: [
      {
        title: 'Báo cáo bán hàng',
        name: 'Reports',
        component: 'Reports'
      },
      {
        title: 'Báo cáo xuất hàng',
        name: 'ReceiptReports',
        component: 'ReceiptReports'
      },
      {
        title: 'Báo cáo trả hàng',
        name: 'ReturnReports',
        component: 'ReturnReports'
      },
    ]
  },
  {
    title: 'Thanh toán',
    group: 'apps',
    icon: 'wallet',
    name: 'Recharges',
    component: 'Recharges',
    roleId: 1
  },
  {
    title: 'Sản phẩm',
    group: 'quan-ly-san-pham',
    icon: 'style',
    name: 'ProductManagement',
    roleId: 1,
    items: [
      {
        title: 'Sản phẩm bán',
        name: 'Products',
        component: 'Products'
      },
      {
        title: 'Sản phẩm xuất', 
        name: 'ExportProducts', 
        component: 'ExportProducts'
      },
      {
        title: 'Sản phẩm sale', 
        name: 'SaleProducts', 
        component: 'SaleProducts'
      },
      {
        title: 'Danh mục', 
        name: 'Categories', 
        component: 'Categories'
      }
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'quan-ly-don-hang',
    icon: 'shopping_cart',
    name: 'OrderManagement',
    roleId: 1,
    items: [
      {
        title: 'Đơn bán',
        name: 'Orders',
        component: 'Orders'
      },
      {
        title: 'Đơn sale',
        name: 'SaleOrders',
        component: 'SaleOrders'
      },
      {
        title: 'Đơn xuất', 
        name: 'ExportOrders', 
        component: 'ExportOrders'
      },
      {
        title: 'Trả hàng', 
        name: 'Returns', 
        component: 'Returns'
      }
    ]
  },
  {
    title: 'Tài khoản',
    group: 'quan-ly-tai-khoan',
    icon: 'manage_accounts',
    name: 'AccountManagement',
    roleId: 1,
    items: [
      {
        title: 'Nhân viên',
        name: 'Users',
        component: 'Users'
      },
      {
        title: 'Khách hàng', 
        name: 'Customers', 
        component: 'Customers'
      }
    ]
  },
  {
    title: 'Nhật ký hệ thống',
    group: 'nhat-ky-he-thong',
    icon: 'schedule',
    name: 'SystemLogs',
    roleId: 1
  },
];
